import { useState } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../store/cart";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function ProductCard({ product, index = 0, drop }) {
  const [size, setSize] = useState(null);
  const [hover, setHover] = useState(false);
  const { addItem } = useCart();

  const second = product.images?.[1] || product.images?.[0];
  // If parent didn't pass a drop number, fall back to index+1
  const dropLabel = String(drop ?? index + 1).padStart(3, "0");

  const quickAdd = (e, s) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, s, 1);
    toast.success(`${product.name} → BAG. SIZE ${s}.`);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setSize(null); }}
      className="group block border border-white/10 bg-surface hard-shadow relative"
    >
      <div className="aspect-[4/5] overflow-hidden bg-ink relative">
        <img
          src={product.images?.[0]}
          alt={product.name}
          className={`absolute inset-0 w-full h-full object-contain transition-all duration-500 ${hover ? "opacity-0 scale-105" : "opacity-100"}`}
        />
        <img
          src={second}
          alt=""
          aria-hidden
          className={`absolute inset-0 w-full h-full object-contain transition-all duration-500 ${hover ? "opacity-100" : "opacity-0"}`}
        />

        {product.featured && (
          <span
            className="absolute top-3 left-3 bg-blood text-bone px-2 py-1 text-[10px] tracking-[0.2em] font-mono z-10"
            data-testid={`product-card-drop-${product.slug}`}
          >
            DROP / {dropLabel}
          </span>
        )}

        {/* Quick add overlay */}
        <div className={`absolute inset-x-0 bottom-0 transition-transform duration-300 ${hover ? "translate-y-0" : "translate-y-full"}`}>
          <div className="bg-ink/95 backdrop-blur border-t border-white/20 p-3">
            <p className="text-[10px] tracking-[0.3em] text-ash font-mono mb-2">// QUICK ADD</p>
            <div className="flex gap-1">
              {product.sizes?.slice(0, 5).map((s) => (
                <button
                  key={s}
                  data-testid={`quick-add-${product.slug}-${s}`}
                  onClick={(e) => quickAdd(e, s)}
                  className="flex-1 min-w-0 px-1 py-2 border border-white/20 text-bone text-xs font-mono hover:bg-blood hover:border-blood transition-colors"
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 border-t border-white/10 flex items-baseline justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-anton text-base sm:text-lg uppercase tracking-tighter text-bone truncate group-hover:text-blood transition-colors">
            {product.name}
          </h3>
          <p className="text-[11px] tracking-[0.2em] uppercase text-ash mt-1 truncate">// {product.category}</p>
        </div>
        <span className="font-mono text-bone text-sm whitespace-nowrap">${product.price.toFixed(2)}</span>
      </div>
    </Link>
  );
}
